// homepageStyles.js

export const classes = {
  homepage: {
    color: '#333',
    lineHeight: 1.5,
  },

  // HERO SECTION
  heroSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f7f7f7',
    padding: '60px 20px',
  },
  heroContent: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '1200px',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  heroImagePlaceholder: {
    width: '400px',
    height: '300px',
    background: '#ccc',
    marginBottom: '20px',
    flex: '1 1 400px',
  },
  heroText: {
    flex: '1 1 400px',
    margin: '0 20px',
  },
  heroTag: {
    textTransform: 'uppercase',
    fontSize: '0.8rem',
    color: '#777',
    letterSpacing: '1px',
    marginBottom: '8px',
  },
  heroTitle: {
    fontSize: '2.4rem',
    marginBottom: '15px',
  },
  heroSubtitle: {
    fontSize: '1.1rem',
    marginBottom: '20px',
    color: '#555',
  },
  heroFeaturesList: {
    listStyleType: 'none',
    paddingLeft: 0,
  },
  heroFeatureItem: {
    marginBottom: '10px',
    paddingLeft: '25px',
    position: 'relative',
    '&::before': {
      content: '"✓"',
      position: 'absolute',
      left: 0,
      color: 'green',
      fontWeight: 'bold',
    },
  },

  // PROBLEM SECTION
  problemSection: {
    textAlign: 'center',
    padding: '60px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  problemHeading: {
    fontSize: '2rem',
    marginBottom: '10px',
  },
  problemSubheading: {
    fontSize: '1.4rem',
    marginBottom: '40px',
    color: '#555',
  },
  problemPoints: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
  },
  problemPoint: {
    maxWidth: '300px',
  },

  // WORKFLOW SECTION
  workflowSection: {
    padding: '60px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  workflowHeading: {
    textAlign: 'center',
    fontSize: '2rem',
    marginBottom: '30px',
  },
  workflowContent: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '50px',
    gap: '20px',
  },
  reverse: {
    // We'll apply this class conditionally via MUI’s `sx` prop merging
    flexDirection: { xs: 'column', md: 'row-reverse' },
  },
  workflowImagePlaceholder: {
    width: '400px',
    height: '250px',
    background: '#ccc',
    flex: '1 1 400px',
  },
  workflowDetails: {
    flex: '1 1 400px',
  },
  workflowTitle: {
    fontSize: '1.5rem',
    marginBottom: '10px',
  },
  workflowText: {
    color: '#555',
  },

  // AI CLAIM SECTION
  aiClaimSection: {
    textAlign: 'center',
    background: '#f7f7f7',
    padding: '40px 20px',
  },
  aiClaim: {
    fontSize: '1.2rem',
    fontWeight: 500,
  },

  // TESTIMONIALS SECTION
  testimonialsSection: {
    padding: '60px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: 'center',
  },
  testimonialsHeading: {
    fontSize: '2rem',
    marginBottom: '30px',
  },
  testimonialCards: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '20px',
  },
  testimonialCard: {
    background: '#fff',
    borderRadius: '4px',
    boxShadow: '0 0 6px rgba(0, 0, 0, 0.1)',
    flex: '1 1 250px',
    maxWidth: '350px',
    padding: '20px',
    textAlign: 'left',
  },
  testimonialName: {
    fontWeight: 'bold',
    marginBottom: '10px',
  },

  // PRICING SECTION
  pricingSection: {
    padding: '60px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: 'center',
  },
  pricingHeading: {
    fontSize: '2rem',
    marginBottom: '40px',
  },
  pricingCards: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    justifyContent: 'center',
  },
  pricingCard: {
    background: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    flex: '1 1 200px',
    maxWidth: '280px',
    padding: '20px',
    textAlign: 'left',
    boxShadow: '0 0 4px rgba(0,0,0,0.05)',
  },
  planName: {
    fontSize: '1.4rem',
    marginBottom: '5px',
  },
  planPrice: {
    display: 'block',
    fontWeight: 'bold',
    marginBottom: '5px',
  },
  planAccounts: {
    color: '#555',
    marginBottom: '15px',
  },
  planFeatures: {
    listStyleType: 'disc',
    paddingLeft: '20px',
    marginBottom: '20px',
  },
};
